import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form'
import user from './user';
import events from './events';
import credentials from './credentials';
import eventDetails from './eventDetails'

const rootReducer = combineReducers({
  form: formReducer,
  user,
  events,
  credentials,
  eventDetails,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js